import React from "react";

export const ComingSoon = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 bg-card-100 dark:bg-card-800 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Coming Soon!</h2>
      <p className="text-gray-600 dark:text-gray-300 text-center">
        This feature is currently under development and will be available soon.
      </p>
    </div>
  );
};
